import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import BundleBuilderForm from './BundleBuilderForm'
import Modal from '../../core/Modal'
import { bundleBuilderFieldPropType } from '../../../propTypes'
import LimitBundleBuilderForm from './LimitBundleBuilderForm'

const BundleBuilderRedirect = ({
  fields,
  eligibleSystemCodes,
  onProceed,
  onCancel,
  isLimitBBRoutingEnabled,
  showSrTicketError,
  pageId,
  cbmLabelRef,
  onCBMScrollChange,
  customerType,
  isOrionSales
}) => {
  const [cbmButtonScrolled, setCbmButtonScrolled] = useState(false)

  useEffect(() => {
    if (onCBMScrollChange) {
      onCBMScrollChange(cbmButtonScrolled)
    }
  }, [
    cbmButtonScrolled,
    onCBMScrollChange
  ])

  function handleOnProceed(data, isLimitBB, isSRTicketRequired) {
    const selected = Object.values(data).filter(({ isSelected }) => isSelected)

    onProceed(selected, isLimitBB, isSRTicketRequired)
  }

  function handleModalClose() {
    if (onCBMScrollChange) {
      onCBMScrollChange(false)
    }
    if (onCancel) {
      onCancel()
    }
  }

  return (
    <>
      {!!fields && (
        <StyledModal
          title={isLimitBBRoutingEnabled ? 'Routing Verification' : ''}
          visible
          allowClose={false}
          footer={false}
          maskClosable={false}
          maskStyle={
            isLimitBBRoutingEnabled && {
              backgroundColor: '#000000d9'
            }
          }
          cbmButtonScrolled={cbmButtonScrolled}
          width={isLimitBBRoutingEnabled ? 650 : 520}
          keyboard={false}
          onCancel={handleModalClose}
        >
          {isLimitBBRoutingEnabled ? (
            <LimitBundleBuilderForm
              fields={fields}
              onCancel={handleModalClose}
              onProceed={handleOnProceed}
              showSrTicketError={showSrTicketError}
            />
          ) : (
            <BundleBuilderForm
              fields={fields}
              onCancel={handleModalClose}
              onProceed={handleOnProceed}
              eligibleSystemCodes={eligibleSystemCodes}
              pageId={pageId}
              cbmLabelRef={cbmLabelRef}
              onCBMScroll={setCbmButtonScrolled}
              customerType={customerType}
              isOrionSales={isOrionSales}
            />
          )}
        </StyledModal>
      )}
    </>
  )
}
BundleBuilderRedirect.propTypes = {
  fields: PropTypes.arrayOf(bundleBuilderFieldPropType),
  onProceed: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isLimitBBRoutingEnabled: PropTypes.bool,
  showSrTicketError: PropTypes.bool,
  eligibleSystemCodes: PropTypes.arrayOf(PropTypes.string),
  pageId: PropTypes.string,
  onCBMScrollChange: PropTypes.func,
  customerType: PropTypes.string,
  cbmLabelRef: PropTypes.object,
  isOrionSales: PropTypes.bool
}

const StyledModal = styled(Modal)`
  .ant-modal-content {
    padding: 5px 10px;
  }

  .ant-modal-header {
    text-align: center;
  }

  .ant-modal-title {
    font-size: 1.2rem;
  }
`

export default BundleBuilderRedirect
